module.exports = __webpack_public_path__ + "static/media/sandwich-bar-menu-long.16151b1f.pdf";